// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Show All Deal Dialog */

.show-all-deal-dialog {
    background-color: #00000000 !important;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;

}

.show-all-deal-dialog .MuiDialog-paper {
    background-color: #fff !important;
    max-width: 900px;
    width: 900px;

}

.show-all-deals-header {
    padding-bottom: 4px !important;
}

.show-all-deals-header .hotel-details {
    margin-top: 8px;
    display: flex;
    align-items: self-start;
    gap: 1rem
}

.show-all-deals-header .hotel-details .hotel-image {
    width: 130px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px
}

.show-all-deals-header .hotel-details .hotel-content {
    width: 100%;
    line-height: 1.55
}

.show-all-deals-header .hotel-details .hotel-content .destination-section,
.show-all-deals-header .hotel-details .hotel-content .rating-section {
    display: flex;
    align-items: center;
    margin-bottom: 3px;
    gap: 5px
}

.show-all-deals-header .hotel-title {
    font-size: 20px;
    margin-bottom: 5px;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deals-header .hotel-details .hotel-content .title {
    color: #000;
    font-size: 14px;
    margin-bottom: 0;
    line-height: 22px;
    font-weight: normal;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deals-header .icon {
    width: 16px;
}

.show-all-deals-title-and-filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 10px;
    background-color: #e5feff;
    border-radius: 8px;
    margin-top: 12px;
}

.show-all-deals-title-and-filters .show-all-deals-title {
    color: #000;
    font-weight: 500;
    font-size: 16px;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deals-filters {
    display: flex;
    align-items: center;
    gap: 1rem
}

.show-all-deals-filters .sort-by-filter .filter-form {
    background: #fff;
    border-radius: 4px;
    border-width: 2px;
    border-color: #c6c6c6;
}

.show-all-deals-filters .sort-by-filter .filter-form .filter-select {
    width: 165px;
    height: 38px;
    font-size: 13px;
    font-weight: 500;
    color: #5e5e5e;
    line-height: 24px;
}

.filter-select-menuItem {
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
    color: rgba(0, 0, 0, 0.87) !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 21px !important;
    min-height: auto !important;
}


.filter-select-menuItem.Mui-selected,
.stay-filters-dropdown .MuiMenu-list.Mui-selected .ListItemText,
.depart-filters-dropdown .MuiMenu-listMui-selected .ListItemText {
    color: #26c6da !important;
}

.filter-select-menuItem:hover {
    color: #26c6da !important;
}


.filter-select-menuItem .ListItemText .MuiListItemText-primary {
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;

}

.filter-select-Checkbox {
    width: 22px;
    height: 22px;
    margin-right: 12px !important;
}

.filter-select-Checkbox svg {
    width: 0.9em;
    height: 0.9em;
}

.Mui-selected.filter-select-menuItem {
    background: transparent !important;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.Mui-selected.filter-select-menuItem .filter-select-Checkbox svg {
    color: #28c6da;

}

.show-all-deals-filters .sort-by-filter .filter-form .filter-label {
    background: #fff;
    padding-right: 4px;
    padding-left: 4px;
    margin-left: -4px;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
    transform: translate(14px, -9px) scale(0.75);
    z-index: 1;
    pointer-events: auto;
}

.show-all-deal-dialog .filter-checkbox {
    width: 18px;
    height: 18px;
    margin-right: 8px;
}

.show-all-deal-dialog .show-all-deals-content {
    padding-top: .5rem !important;
    max-height: calc(100svh - 280px) !important
}

.show-all-deal-dialog .deal-item-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: .5rem;
    flex-wrap: nowrap;
}

.deal-item-container .deal-item-part-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 60%;
    gap: 2px;
    flex-wrap: wrap;
}

.show-all-deal-dialog .date-range-container {
    display: flex;
    align-items: start;
    gap: 5px;
    color: #000;
}

.deal-item-container .deal-date-range .date-range {
    font-size: 14px !important;
    font-weight: 500;
    color: #2f2f2f !important;
}

.show-all-deal-dialog .date-range-container .date-range {
    font-size: 13px;
    color: #000;
    display: flex;
    gap: 0px;
    flex-wrap: wrap;
    white-space: nowrap;
}

.show-all-deal-dialog .deal-item-container.is-recommended .deal-date-range .date-range {
    color: #db487e !important;
}

.show-all-deal-dialog .deal-item-container .nights-flights {
    font-size: 14px;
    color: #2f2f2f !important;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
}

.show-all-deal-dialog .deal-item-container .nights-flights {
    width: 40%;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deal-dialog .deal-item-container .flights-and-hotels-text {
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deal-dialog .deal-item-container .deal-item-part-right {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: .5rem;
    flex-wrap: nowrap;
}

.show-all-deal-dialog .deal-item-container .price-container {
    display: flex;
    align-items: center;
    text-align: center;
    display: block !important;
    line-height: 1.2;
    margin-left: auto;
}

.show-all-deal-dialog .deal-item-container .price-container .price {
    color: #db487e;
    font-size: 16px;
    margin-right: 4px;
    font-family: Segoe UI, Tahoma, Geneva, Verdana, sans-serif !important;
    font-weight: 700 !important;
}

.show-all-deal-dialog .deal-item-container .price-container .per-person {
    font-size: 11px;
    color: #454545;
    line-height: 1.1;
}

.show-all-deal-dialog .deal-item-container .price-container .per-person {
    color: #2f2f2f !important;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deal-dialog .deal-item-container .deal-item-part-right .book-btn-container {
    margin-left: auto;
}


.show-all-deal-dialog .book-btn {
    border: 2px solid #25c9d0;
    background-color: transparent !important;
    box-shadow: none;
    font-size: 15px;
    font-weight: 500;
    color: #000;
    border-radius: 4px;
    padding: 4px 18px;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deal-dialog .show-all-deal-dialog .book-btn:hover {
    border: 2px solid #25c9d0;
    background-color: #25c9d0 !important;
}

.show-all-deal-dialog .custom-scrollbar::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #dddddd;
}

.show-all-deal-dialog .custom-scrollbar::-webkit-scrollbar {
    width: 5px;
}

.show-all-deal-dialog .custom-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 8px;
    height: 20px;
    background-color: #919191 !important;
}

.show-all-deal-dialog .DialogActions {
    position: absolute;
    top: 0;
    right: 0;
}

.show-all-deal-dialog .DialogActions button {
    min-width: auto;
    color: #7f7f7f;
}

.show-all-deal-dialog .DialogActions button:hover {
    color: #000
}

.show-all-deals-content .disclaimer {
    padding-bottom: 20px;
}

.show-all-deals-content .taxes-fee {
    font-size: 12px;
    text-align: center;
    color: #454545;
    margin: 1rem 0 5px;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.show-all-deals-content .package-price-text {
    font-size: 12px;
    text-align: center;
    color: #454545;
    margin-bottom: 1rem;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.deal-item-container .nights-flights {
    font-size: 14px;
    color: #2f2f2f !important;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
}

.deal-item-container .nights-flights {
    width: 40%;
}

.deal-item-container .nights-flights .flights-and-hotels-icons {
    display: none;
    padding-top: 2px;
}

.deal-item-container .nights-flights .flights-and-hotels-icons .icon {
    width: 18px;
    margin-right: 4px;
}

.deal-item-container .nights-flights .flights-and-hotels-icons .mat-icon {
    height: 18px;
    width: 20px;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.deal-item-container .nights-flights .flights-and-hotels-text {
    display: block;
}







/* Mobile view css  */

@media screen and (max-width:900px) {
    .show-all-deal-dialog .MuiDialog-paper {
        margin: 0;
        /* zoom: 95%; */
        max-width: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        height: 100vh;
        border-radius: 0;
        max-height: 100%;
    }
}

@media screen and (max-width: 768px) {
    .show-all-deal-dialog {
        /* zoom: 90% !important; */
    }

    .show-all-deal-dialog .show-all-deals-header .hotel-details {
        zoom: 90%;
    }

    .show-all-deal-dialog .show-all-deals-content {
        /* zoom: 80%; */
        zoom: 63%;
    }

    .show-all-deal-dialog .deal-item-container .price-container .price {
        font-size: 14px;
    }

    .show-all-deal-dialog .book-btn {
        font-size: 14px;
    }

    .show-all-deal-dialog .show-all-deals-header {
        margin-top: 16px;
    }

    .filter-select-menuItem .ListItemText .MuiListItemText-primary {
        font-size: 14px;
    }

    .filter-select-Checkbox svg {
        width: 0.6em;
        height: 0.6em;
    }

    .show-all-deals-filters .sort-by-filter .filter-form .filter-label {
        padding-left: 8px;
        padding-right: 8px;
    }

}

@media screen and (max-width: 576px) {
    .deal-item-container .nights-flights {
        width: 100%;
    }

    .deal-item-container .nights-flights .flights-and-hotels-icons {
        display: block;
    }

    .deal-item-container .nights-flights .flights-and-hotels-text {
        display: none;
    }

    .deal-item-container .deal-item-part-left {
        width: 40%;
    }

    .deal-item-container .deal-item-part-right {
        width: 55% !important;
    }

    .deal-item-container .deal-item-part-left,
    .deal-item-container .deal-item-part-right {
        width: 40%;
        display: block;
    }

    .show-all-deal-dialog .show-all-deals-header .hotel-details {
        /* zoom: 78%; */
        zoom: 72%;

    }
    .show-all-deal-dialog .date-range-container .date-range{
        /* flex-wrap: nowrap; */
        display: block;
    }

    /* font styles css */

    .deal-item-container .deal-date-range .date-range{
        font-size: 12px !important;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .nights-flights{
        font-size: 12px !important;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .price-container .price{
        font-size: 13px;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .price-container .per-person{
        letter-spacing: -1px;
    }

}



@media (max-width: 420px) {
    .show-all-deal-dialog .show-all-deals-content {
        /* zoom: 75%; */
        zoom: 70%;

    }

    .show-all-deal-dialog .show-all-deals-header .hotel-details {
        zoom: 60%;
    }


}


@media screen and (max-width: 768px) {
    .show-all-deals-title-and-filters {
        display: block;
    }

    .show-all-deals-filters {
        gap: 3px;

    }

    .show-all-deals-filters .custom-filters {
        width: 33%;
    }

    .show-all-deals-filters .custom-filters .filter-form .filter-select {
        height: 30px;
        font-size: 10px;
        width: 100%;
    }

    .show-all-deals-filters .custom-filters .filter-form .filter-label {
        font-size: 10px;
    }

    .show-all-deals-title-and-filters .show-all-deals-title {
        margin-bottom: 16px;
        font-size: 12px;
    }

}




@media only screen and (max-width: 420px) {
  
    .show-all-deal-dialog .book-btn {
        padding-left: 8px !important;
        padding-right: 8px !important;
        font-size: 12px !important;
    }
}

@supports (-webkit-touch-callout: none) {
    @media only screen and (max-width: 420px) {
        .show-all-deal-dialog .book-btn {
            padding-left: 8px !important;
            padding-right: 8px !important;
            font-size: 12px !important;
        }
    }
}



@media (max-width: 390px) and (max-height: 664px)    {
    /* Your styles here */
     
    .deal-item-container .deal-date-range .date-range{
        font-size: 12px !important;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .nights-flights{
        font-size: 12px !important;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .price-container .price{
        font-size: 13px;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .price-container .per-person{
        letter-spacing: -1px;
    }
  }
  
@media (max-width: 390px) and (max-height: 844px )    {
    /* Your styles here */
     
    .deal-item-container .deal-date-range .date-range{
        font-size: 12px !important;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .nights-flights{
        font-size: 12px !important;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .price-container .price{
        font-size: 13px;
        letter-spacing: -1px;
    }
    .show-all-deal-dialog .deal-item-container .price-container .per-person{
        letter-spacing: -1px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/show_all_dialog.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;IACI,sCAAsC;IACtC,gEAAgE;;AAEpE;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gEAAgE;AACpE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gEAAgE;IAChE,qCAAqC;IACrC,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;AAC/B;;;AAGA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gEAAgE;;AAEpE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,gEAAgE;AACpE;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gEAAgE;IAChE,4CAA4C;IAC5C,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gEAAgE;AACpE;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qEAAqE;IACrE,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gEAAgE;AACpE;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gEAAgE;AACpE;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;;;;;;;AAQA,qBAAqB;;AAErB;IACI;QACI,SAAS;QACT,eAAe;QACf,eAAe;QACf,WAAW;QACX,eAAe;QACf,MAAM;QACN,aAAa;QACb,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;AAEJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,SAAS;;IAEb;IACA;QACI,uBAAuB;QACvB,cAAc;IAClB;;IAEA,oBAAoB;;IAEpB;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;;AAEJ;;;;AAIA;IACI;QACI,eAAe;QACf,SAAS;;IAEb;;IAEA;QACI,SAAS;IACb;;;AAGJ;;;AAGA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,QAAQ;;IAEZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;AAEJ;;;;;AAKA;;IAEI;QACI,4BAA4B;QAC5B,6BAA6B;QAC7B,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI;YACI,4BAA4B;YAC5B,6BAA6B;YAC7B,0BAA0B;QAC9B;IACJ;AACJ;;;;AAIA;IACI,qBAAqB;;IAErB;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;EACF;;AAEF;IACI,qBAAqB;;IAErB;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;EACF","sourcesContent":["/* Show All Deal Dialog */\n\n.show-all-deal-dialog {\n    background-color: #00000000 !important;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n\n}\n\n.show-all-deal-dialog .MuiDialog-paper {\n    background-color: #fff !important;\n    max-width: 900px;\n    width: 900px;\n\n}\n\n.show-all-deals-header {\n    padding-bottom: 4px !important;\n}\n\n.show-all-deals-header .hotel-details {\n    margin-top: 8px;\n    display: flex;\n    align-items: self-start;\n    gap: 1rem\n}\n\n.show-all-deals-header .hotel-details .hotel-image {\n    width: 130px;\n    height: 80px;\n    object-fit: cover;\n    border-radius: 8px\n}\n\n.show-all-deals-header .hotel-details .hotel-content {\n    width: 100%;\n    line-height: 1.55\n}\n\n.show-all-deals-header .hotel-details .hotel-content .destination-section,\n.show-all-deals-header .hotel-details .hotel-content .rating-section {\n    display: flex;\n    align-items: center;\n    margin-bottom: 3px;\n    gap: 5px\n}\n\n.show-all-deals-header .hotel-title {\n    font-size: 20px;\n    margin-bottom: 5px;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deals-header .hotel-details .hotel-content .title {\n    color: #000;\n    font-size: 14px;\n    margin-bottom: 0;\n    line-height: 22px;\n    font-weight: normal;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deals-header .icon {\n    width: 16px;\n}\n\n.show-all-deals-title-and-filters {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1rem;\n    padding: 10px;\n    background-color: #e5feff;\n    border-radius: 8px;\n    margin-top: 12px;\n}\n\n.show-all-deals-title-and-filters .show-all-deals-title {\n    color: #000;\n    font-weight: 500;\n    font-size: 16px;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deals-filters {\n    display: flex;\n    align-items: center;\n    gap: 1rem\n}\n\n.show-all-deals-filters .sort-by-filter .filter-form {\n    background: #fff;\n    border-radius: 4px;\n    border-width: 2px;\n    border-color: #c6c6c6;\n}\n\n.show-all-deals-filters .sort-by-filter .filter-form .filter-select {\n    width: 165px;\n    height: 38px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #5e5e5e;\n    line-height: 24px;\n}\n\n.filter-select-menuItem {\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n    color: rgba(0, 0, 0, 0.87) !important;\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    line-height: 21px !important;\n    min-height: auto !important;\n}\n\n\n.filter-select-menuItem.Mui-selected,\n.stay-filters-dropdown .MuiMenu-list.Mui-selected .ListItemText,\n.depart-filters-dropdown .MuiMenu-listMui-selected .ListItemText {\n    color: #26c6da !important;\n}\n\n.filter-select-menuItem:hover {\n    color: #26c6da !important;\n}\n\n\n.filter-select-menuItem .ListItemText .MuiListItemText-primary {\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n\n}\n\n.filter-select-Checkbox {\n    width: 22px;\n    height: 22px;\n    margin-right: 12px !important;\n}\n\n.filter-select-Checkbox svg {\n    width: 0.9em;\n    height: 0.9em;\n}\n\n.Mui-selected.filter-select-menuItem {\n    background: transparent !important;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.Mui-selected.filter-select-menuItem .filter-select-Checkbox svg {\n    color: #28c6da;\n\n}\n\n.show-all-deals-filters .sort-by-filter .filter-form .filter-label {\n    background: #fff;\n    padding-right: 4px;\n    padding-left: 4px;\n    margin-left: -4px;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n    transform: translate(14px, -9px) scale(0.75);\n    z-index: 1;\n    pointer-events: auto;\n}\n\n.show-all-deal-dialog .filter-checkbox {\n    width: 18px;\n    height: 18px;\n    margin-right: 8px;\n}\n\n.show-all-deal-dialog .show-all-deals-content {\n    padding-top: .5rem !important;\n    max-height: calc(100svh - 280px) !important\n}\n\n.show-all-deal-dialog .deal-item-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    gap: .5rem;\n    flex-wrap: nowrap;\n}\n\n.deal-item-container .deal-item-part-left {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 60%;\n    gap: 2px;\n    flex-wrap: wrap;\n}\n\n.show-all-deal-dialog .date-range-container {\n    display: flex;\n    align-items: start;\n    gap: 5px;\n    color: #000;\n}\n\n.deal-item-container .deal-date-range .date-range {\n    font-size: 14px !important;\n    font-weight: 500;\n    color: #2f2f2f !important;\n}\n\n.show-all-deal-dialog .date-range-container .date-range {\n    font-size: 13px;\n    color: #000;\n    display: flex;\n    gap: 0px;\n    flex-wrap: wrap;\n    white-space: nowrap;\n}\n\n.show-all-deal-dialog .deal-item-container.is-recommended .deal-date-range .date-range {\n    color: #db487e !important;\n}\n\n.show-all-deal-dialog .deal-item-container .nights-flights {\n    font-size: 14px;\n    color: #2f2f2f !important;\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    white-space: nowrap;\n}\n\n.show-all-deal-dialog .deal-item-container .nights-flights {\n    width: 40%;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deal-dialog .deal-item-container .flights-and-hotels-text {\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deal-dialog .deal-item-container .deal-item-part-right {\n    width: 40%;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    gap: .5rem;\n    flex-wrap: nowrap;\n}\n\n.show-all-deal-dialog .deal-item-container .price-container {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    display: block !important;\n    line-height: 1.2;\n    margin-left: auto;\n}\n\n.show-all-deal-dialog .deal-item-container .price-container .price {\n    color: #db487e;\n    font-size: 16px;\n    margin-right: 4px;\n    font-family: Segoe UI, Tahoma, Geneva, Verdana, sans-serif !important;\n    font-weight: 700 !important;\n}\n\n.show-all-deal-dialog .deal-item-container .price-container .per-person {\n    font-size: 11px;\n    color: #454545;\n    line-height: 1.1;\n}\n\n.show-all-deal-dialog .deal-item-container .price-container .per-person {\n    color: #2f2f2f !important;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deal-dialog .deal-item-container .deal-item-part-right .book-btn-container {\n    margin-left: auto;\n}\n\n\n.show-all-deal-dialog .book-btn {\n    border: 2px solid #25c9d0;\n    background-color: transparent !important;\n    box-shadow: none;\n    font-size: 15px;\n    font-weight: 500;\n    color: #000;\n    border-radius: 4px;\n    padding: 4px 18px;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deal-dialog .show-all-deal-dialog .book-btn:hover {\n    border: 2px solid #25c9d0;\n    background-color: #25c9d0 !important;\n}\n\n.show-all-deal-dialog .custom-scrollbar::-webkit-scrollbar-track {\n    border-radius: 8px;\n    background-color: #dddddd;\n}\n\n.show-all-deal-dialog .custom-scrollbar::-webkit-scrollbar {\n    width: 5px;\n}\n\n.show-all-deal-dialog .custom-scrollbar::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    height: 20px;\n    background-color: #919191 !important;\n}\n\n.show-all-deal-dialog .DialogActions {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.show-all-deal-dialog .DialogActions button {\n    min-width: auto;\n    color: #7f7f7f;\n}\n\n.show-all-deal-dialog .DialogActions button:hover {\n    color: #000\n}\n\n.show-all-deals-content .disclaimer {\n    padding-bottom: 20px;\n}\n\n.show-all-deals-content .taxes-fee {\n    font-size: 12px;\n    text-align: center;\n    color: #454545;\n    margin: 1rem 0 5px;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.show-all-deals-content .package-price-text {\n    font-size: 12px;\n    text-align: center;\n    color: #454545;\n    margin-bottom: 1rem;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.deal-item-container .nights-flights {\n    font-size: 14px;\n    color: #2f2f2f !important;\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    white-space: nowrap;\n}\n\n.deal-item-container .nights-flights {\n    width: 40%;\n}\n\n.deal-item-container .nights-flights .flights-and-hotels-icons {\n    display: none;\n    padding-top: 2px;\n}\n\n.deal-item-container .nights-flights .flights-and-hotels-icons .icon {\n    width: 18px;\n    margin-right: 4px;\n}\n\n.deal-item-container .nights-flights .flights-and-hotels-icons .mat-icon {\n    height: 18px;\n    width: 20px;\n    font-size: 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.deal-item-container .nights-flights .flights-and-hotels-text {\n    display: block;\n}\n\n\n\n\n\n\n\n/* Mobile view css  */\n\n@media screen and (max-width:900px) {\n    .show-all-deal-dialog .MuiDialog-paper {\n        margin: 0;\n        /* zoom: 95%; */\n        max-width: 100%;\n        width: 100%;\n        position: fixed;\n        top: 0;\n        height: 100vh;\n        border-radius: 0;\n        max-height: 100%;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .show-all-deal-dialog {\n        /* zoom: 90% !important; */\n    }\n\n    .show-all-deal-dialog .show-all-deals-header .hotel-details {\n        zoom: 90%;\n    }\n\n    .show-all-deal-dialog .show-all-deals-content {\n        /* zoom: 80%; */\n        zoom: 63%;\n    }\n\n    .show-all-deal-dialog .deal-item-container .price-container .price {\n        font-size: 14px;\n    }\n\n    .show-all-deal-dialog .book-btn {\n        font-size: 14px;\n    }\n\n    .show-all-deal-dialog .show-all-deals-header {\n        margin-top: 16px;\n    }\n\n    .filter-select-menuItem .ListItemText .MuiListItemText-primary {\n        font-size: 14px;\n    }\n\n    .filter-select-Checkbox svg {\n        width: 0.6em;\n        height: 0.6em;\n    }\n\n    .show-all-deals-filters .sort-by-filter .filter-form .filter-label {\n        padding-left: 8px;\n        padding-right: 8px;\n    }\n\n}\n\n@media screen and (max-width: 576px) {\n    .deal-item-container .nights-flights {\n        width: 100%;\n    }\n\n    .deal-item-container .nights-flights .flights-and-hotels-icons {\n        display: block;\n    }\n\n    .deal-item-container .nights-flights .flights-and-hotels-text {\n        display: none;\n    }\n\n    .deal-item-container .deal-item-part-left {\n        width: 40%;\n    }\n\n    .deal-item-container .deal-item-part-right {\n        width: 55% !important;\n    }\n\n    .deal-item-container .deal-item-part-left,\n    .deal-item-container .deal-item-part-right {\n        width: 40%;\n        display: block;\n    }\n\n    .show-all-deal-dialog .show-all-deals-header .hotel-details {\n        /* zoom: 78%; */\n        zoom: 72%;\n\n    }\n    .show-all-deal-dialog .date-range-container .date-range{\n        /* flex-wrap: nowrap; */\n        display: block;\n    }\n\n    /* font styles css */\n\n    .deal-item-container .deal-date-range .date-range{\n        font-size: 12px !important;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .nights-flights{\n        font-size: 12px !important;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .price-container .price{\n        font-size: 13px;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .price-container .per-person{\n        letter-spacing: -1px;\n    }\n\n}\n\n\n\n@media (max-width: 420px) {\n    .show-all-deal-dialog .show-all-deals-content {\n        /* zoom: 75%; */\n        zoom: 70%;\n\n    }\n\n    .show-all-deal-dialog .show-all-deals-header .hotel-details {\n        zoom: 60%;\n    }\n\n\n}\n\n\n@media screen and (max-width: 768px) {\n    .show-all-deals-title-and-filters {\n        display: block;\n    }\n\n    .show-all-deals-filters {\n        gap: 3px;\n\n    }\n\n    .show-all-deals-filters .custom-filters {\n        width: 33%;\n    }\n\n    .show-all-deals-filters .custom-filters .filter-form .filter-select {\n        height: 30px;\n        font-size: 10px;\n        width: 100%;\n    }\n\n    .show-all-deals-filters .custom-filters .filter-form .filter-label {\n        font-size: 10px;\n    }\n\n    .show-all-deals-title-and-filters .show-all-deals-title {\n        margin-bottom: 16px;\n        font-size: 12px;\n    }\n\n}\n\n\n\n\n@media only screen and (max-width: 420px) {\n  \n    .show-all-deal-dialog .book-btn {\n        padding-left: 8px !important;\n        padding-right: 8px !important;\n        font-size: 12px !important;\n    }\n}\n\n@supports (-webkit-touch-callout: none) {\n    @media only screen and (max-width: 420px) {\n        .show-all-deal-dialog .book-btn {\n            padding-left: 8px !important;\n            padding-right: 8px !important;\n            font-size: 12px !important;\n        }\n    }\n}\n\n\n\n@media (max-width: 390px) and (max-height: 664px)    {\n    /* Your styles here */\n     \n    .deal-item-container .deal-date-range .date-range{\n        font-size: 12px !important;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .nights-flights{\n        font-size: 12px !important;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .price-container .price{\n        font-size: 13px;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .price-container .per-person{\n        letter-spacing: -1px;\n    }\n  }\n  \n@media (max-width: 390px) and (max-height: 844px )    {\n    /* Your styles here */\n     \n    .deal-item-container .deal-date-range .date-range{\n        font-size: 12px !important;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .nights-flights{\n        font-size: 12px !important;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .price-container .price{\n        font-size: 13px;\n        letter-spacing: -1px;\n    }\n    .show-all-deal-dialog .deal-item-container .price-container .per-person{\n        letter-spacing: -1px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
